export default class Utils
{
	static FillDropdown(selectElement, catalog, extraData = null, nameGetter = null, defaultText = null, idGetter = null)
	{
		while (selectElement.options && selectElement.options.length > 0)
		{
			selectElement.options.remove(0);
		}

		const defaultOpt = document.createElement('option');
		defaultOpt.value = "-1";
		defaultOpt.text = defaultText ? defaultText : "Select...";
		selectElement.add(defaultOpt);
		if (Array.isArray(catalog)) {

		catalog.forEach((cat) =>
		{
			const newOpt = document.createElement('option');
			newOpt.value = idGetter ? idGetter(cat) : cat.id;
			newOpt.text = nameGetter ? nameGetter(cat) : cat.name;
			// if (defaultNameValue && nameGetter(cat) === defaultNameValue) {
            //     newOpt.value = defaultNameValue; 
            // }
			if (extraData !== null)
				extraData.forEach(item => newOpt.dataset[item] = cat[item]);
			selectElement.add(newOpt);
		});
	}else {
		console.error('catalog is not an array', catalog);
	  }
	}

	static valInput(input)
	{
		return !!input ? input.value : "";
	}

	static deleteTags(str) {
		return typeof str !== 'string' ? str : str.replace(/(<([^>]+)>)/ig, '')
	}

	static percentFormat(number) {
		return  new Intl.NumberFormat("en-US", {
			style: 'percent',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}).format(number)
	}
}